import React from 'react'
import PropTypes from 'prop-types'
import { compose, setPropTypes, defaultProps } from 'recompose'
import { Button, Icon } from 'semantic-ui-react'
import { CustomButtonContainer } from './styled'

const CustomButton = (props) => {
  const { title, icon, onClick, btnColor, disable, hide, styled, type, fullWidth, loading } = props
  return (
    hide ? null :
    <CustomButtonContainer style={styled}>
      <Button 
        loading={loading}
        type={type} 
        disabled={disable || loading} 
        className={`customButton ${btnColor}`} 
        style={{ width: fullWidth ? '100%' : '' }} 
        onClick={onClick}>
        <div style={{color:'#fff'}}>{icon !== '' ? <Icon name={icon}/> : null}</div>
        <div className='btnTitle'>{title}</div>
      </Button>
    </CustomButtonContainer>
  )
}

const propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  btnColor: PropTypes.string.isRequired,
  disable: PropTypes.bool,
  hide: PropTypes.bool,
  styled: PropTypes.object,
  type: PropTypes.string,
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
}

const defaultProp = {
  disable: false,
  icon: '',
  styled: {},
  type: 'button',
  hide: false,
  fullWidth: false,
  onClick: () => {},
  loading: false,
}

export default compose(
  setPropTypes(propTypes),
  defaultProps(defaultProp)
)(CustomButton)
